import React from 'react'

const TagIcon = () => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_719_14692)'>
      <path
        d='M11.6062 0.410915C11.3487 0.15342 11.0003 0.00195312 10.6519 0.00195312L6.6835 0.0170999H6.66835C6.06248 0.0625401 5.47176 0.335181 5.04765 0.75929L0.397602 5.37905C-0.132534 5.90918 -0.132534 6.78769 0.397602 7.31783L4.68413 11.6044C4.94162 11.8618 5.29 11.9982 5.66867 11.9982C6.04733 11.9982 6.38056 11.8618 6.62291 11.5892L11.2275 6.9846C11.6668 6.56049 11.9394 5.98491 11.9849 5.3639V5.34875L12 1.39545C12 1.01678 11.8637 0.66841 11.6062 0.410915ZM7.5923 5.57595C6.94099 5.57595 6.41086 5.04582 6.41086 4.39451C6.41086 3.7432 6.94099 3.21306 7.5923 3.21306C8.24361 3.21306 8.77375 3.7432 8.77375 4.39451C8.77375 5.04582 8.24361 5.57595 7.5923 5.57595Z'
        fill='#8F8F8F'
      />
    </g>
    <defs>
      <clipPath id='clip0_719_14692'>
        <rect width='12' height='12' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default TagIcon
